<section class="p-3">

  <lib-dialog-header
    [titulok]="'Odkaz z e-nástenky'"
    [skratkyANazvyPredmetov]="detail.skratkyANazvyPredmetov">
  </lib-dialog-header>

  <mat-dialog-content style="min-width: 400px;">
      <mat-spinner *ngIf="loading" class="m-5"></mat-spinner>

      <h2><span i18n>Zaevidoval</span></h2>
      <p>{{detail.datumCas}}<br/>{{detail.zapisal}}</p>

      <hr/>

      <h2>{{detail.nadpis}}</h2>
      <p>{{detail.text}}</p>
  </mat-dialog-content>

  <hr/>

  <mat-dialog-actions class="d-flex justify-content-end">
      <button mat-stroked-button mat-dialog-close #initialButton><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>

